import * as auth from "../api/auth";
import { call, fork, put, take, takeLatest } from "redux-saga/effects";
import { NavLink, useNavigate } from "react-router-dom";
import authActions from "../slices/authSlice";

//로그인
function* requestFetchLogin(payload) {
  const params = payload.payload;
  const { response, err } = yield call(auth.requestLogin, params);
  const loginLogic = (res, autoLogin) => {
    // console.log(autoLogin);
    if (autoLogin) {
      localStorage.setItem("token", res.params.accessToken);
      window.location.replace("/home");
    } else {
      sessionStorage.setItem("token", res.params.accessToken);
      window.location.replace("/home");
    }
  };
  if (response) {
    yield put(authActions.actions.fetchLoginSuccess({ response, params }));

    yield loginLogic(response.data, params.params.autologin);
  } else {
    yield put(authActions.actions.fetchLoginFailure(err));
  }
}
//로그아웃
function* requestFetchLogout(payload) {
  const params = payload.payload;
  const { response, err } = yield call(auth.requestLogout, params);
  const logoutLogic = (params) => {
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    // console.log("로그아웃 로직", params.page);
    if (params.page == "login") {
      window.location.replace("/login");
    } else {
      window.location.replace("/home");
    }
  };
  if (response) {
    yield put(authActions.actions.fetchLogoutSuccess(response));
    yield logoutLogic(params);
  } else {
    yield put(authActions.actions.fetchLogoutFailure(err));
  }
}

//회원가입
function* requestFetchSignUp(payload) {
  const params = payload.payload;
  const { response, err } = yield call(auth.requestSignUp, params);

  if (response) {
    yield put(authActions.actions.fetchSignUpSuccess(response));
  } else {
    yield put(authActions.actions.fetchSignUpFailure(err));
  }
}
//회원 중복 체크
function* requestFetchAuthCheck(payload) {
  const params = payload.payload;
  const { response, err } = yield call(auth.requestAuthCheck, params);

  if (response) {
    yield put(authActions.actions.fetchAuthCheckSuccess({ response, params }));
  } else {
    yield put(authActions.actions.fetchAuthCheckFailure({ err, params }));
  }
}

//이메일 인증 요청
function* requestFetchSendEmailConfirm(payload) {
  const params = payload.payload;
  const { response, err } = yield call(auth.requestSendEmailConfirm, params);

  if (response) {
    yield put(authActions.actions.fetchSendEmailConfirmSuccess(response));
  } else {
    yield put(authActions.actions.fetchSendEmailConfirmFailure(err));
  }
}

//회원탈퇴
function* requestFetchWithdrawal(payload) {
  const params = payload.payload;
  const { response, err } = yield call(auth.requestWithdrawal, params);
  const logoutLogic = () => {
    localStorage.removeItem("token");
  };
  if (response) {
    yield put(authActions.actions.fetchWithdrawalSuccess(response));
    yield logoutLogic();
  } else {
    yield put(authActions.actions.fetchWithdrawalFailure(err));
  }
}

////비밀번호 재설정(본인인증 이후, 로그인 못한 상태)
function* requestFetchReSettingPassword(payload) {
  const params = payload.payload;
  const { response, err } = yield call(auth.requestReSettingPassword, params);

  if (response) {
    yield put(authActions.actions.fetchReSettingPasswordSuccess(response));
  } else {
    yield put(authActions.actions.fetchReSettingPasswordFailure(err));
  }
}

export default function* watchAuth() {
  yield takeLatest(authActions.actions.fetchLogin, requestFetchLogin);
  yield takeLatest(authActions.actions.fetchLogout, requestFetchLogout);
  yield takeLatest(authActions.actions.fetchSignUp, requestFetchSignUp);
  yield takeLatest(authActions.actions.fetchAuthCheck, requestFetchAuthCheck);
  yield takeLatest(
    authActions.actions.fetchSendEmailConfirm,
    requestFetchSendEmailConfirm
  );

  yield takeLatest(authActions.actions.fetchWithdrawal, requestFetchWithdrawal);
  yield takeLatest(
    authActions.actions.fetchReSettingPassword,
    requestFetchReSettingPassword
  );
}
